/*
 * /dental-tax-deduction — сколько вернут за лечение зубов.
 *
 * Калькуляторы на сайтах клиник поголовно считают «13 % от суммы, но не
 * больше 15 600». Оба числа устарели:
 *
 *  1. С 2024 года социальный лимит 150 000 ₽, а не 120 000 → потолок
 *     возврата по обычному лечению 19 500 ₽, а не 15 600.
 *  2. ⚠️⚠️ С 2025 года НДФЛ ПРОГРЕССИВНЫЙ (13 / 15 / 18 / 20 / 22 %), и
 *     вычет возвращается ПО СТАВКЕ плательщика. Человеку с доходом выше
 *     2,4 млн ₽ калькулятор «по 13 %» занижает возврат, и он подаёт на
 *     меньшее, чем ему причитается.
 *
 * И третье, чего нет нигде: у ЛЕЧЕНИЯ ЗУБОВ есть две категории, и разница
 * между ними больше, чем всё остальное вместе. Обычное лечение (код услуги
 * 1 в справке) упирается в лимит 150 000; дорогостоящее (код 2 — сюда
 * входит имплантация) вычитается БЕЗ ЛИМИТА. Человек, у которого импланты
 * записаны кодом 1, теряет десятки тысяч и не знает об этом. Поэтому тул
 * считает ОБА варианта и показывает разницу как повод сходить в клинику за
 * правильной справкой.
 */

const CFG = window.__TAX || {};
const T = CFG.i18n || {};
const $ = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));

const state = {
    income: 0,
    simple: 0,      // код 1 — обычное лечение
    expensive: 0,   // код 2 — дорогостоящее
    otherSocial: 0, // другие социальные вычеты, уже заявленные за тот же год
};

// ── налог ───────────────────────────────────────────────────────────────

/**
 * НДФЛ по прогрессивной шкале. Ставка применяется к ЧАСТИ дохода внутри
 * своей ступени, а не ко всему доходу целиком — это разное, и на этом
 * ошибаются чаще всего.
 */
function taxOn(income) {
    const br = CFG.brackets;
    let tax = 0;
    for (let i = 0; i < br.length; i++) {
        const from = br[i][0];
        const to = i + 1 < br.length ? br[i + 1][0] : Infinity;
        if (income <= from) break;
        tax += (Math.min(income, to) - from) * br[i][1];
    }
    return tax;
}

/**
 * Возврат = налог с полного дохода минус налог с дохода, уменьшенного на
 * вычет. Так учитывается прогрессия автоматически: у человека на границе
 * ступени часть вычета вернётся по верхней ставке, часть по нижней.
 */
function refundFor(income, deduction) {
    const d = Math.min(deduction, income);
    return taxOn(income) - taxOn(income - d);
}

/** Эффективная ставка возврата — то, что человек назовёт «сколько процентов». */
function effectiveRate(income, deduction) {
    const d = Math.min(deduction, income);
    return d > 0 ? refundFor(income, d) / d : 0;
}

// ── расчёт ──────────────────────────────────────────────────────────────

function compute() {
    const limit = CFG.socialLimit;

    // Обычное лечение делит лимит с другими социальными вычетами того же
    // года (обучение, фитнес, ДМС) — про это забывают и удивляются отказу.
    const roomInLimit = Math.max(0, limit - state.otherSocial);
    const simpleCounted = Math.min(state.simple, roomInLimit);
    const simpleCut = state.simple - simpleCounted;

    const deduction = simpleCounted + state.expensive;
    const refund = refundFor(state.income, deduction);
    const tax = taxOn(state.income);

    /*
     * Возврат не может превысить уплаченный НДФЛ — второй потолок, и он
     * бьёт по тем, у кого дорогая имплантация при скромной зарплате.
     *
     * ⚠️ Признак — «вычет БОЛЬШЕ облагаемого дохода», а не «возврат больше
     * налога». Второе не срабатывает никогда: зажим уже произошёл внутри
     * refundFor (там `Math.min(deduction, income)`), и сравнение выходило
     * на равенство. Предупреждение молча не показывалось ровно тем, кому
     * оно нужнее всего — найдено сценарием «доход 300 000, лечение 600 000».
     */
    const capped = deduction > state.income;

    // Что было бы, если бы ВСЁ записали кодом 1 (обычное лечение). Это и
    // есть цена неправильной справки.
    const allSimpleCounted = Math.min(state.simple + state.expensive, roomInLimit);
    const refundIfAllSimple = refundFor(state.income, allSimpleCounted);

    return {
        deduction, refund: Math.min(refund, tax), tax, capped,
        simpleCounted, simpleCut, roomInLimit,
        rate: effectiveRate(state.income, deduction),
        refundIfAllSimple,
        codeGain: refund - refundIfAllSimple,
    };
}

// ── интерфейс ───────────────────────────────────────────────────────────

function boot() {
    $$('.tx-in').forEach(el => {
        el.addEventListener('input', () => {
            state[el.dataset.field] = parseMoney(el.value);
            render();
        });
    });
    $('#txCopy').addEventListener('click', copySummary);
    render();
    if (window.__stage) window.__stage('ready');
}

function parseMoney(v) {
    const n = parseFloat(String(v).replace(/[\s ]/g, '').replace(',', '.'));
    return isFinite(n) && n > 0 ? n : 0;
}

function render() {
    const spent = state.simple + state.expensive;
    const has = state.income > 0 && spent > 0;

    $('#txEmpty').hidden = has;
    $('#txResult').hidden = !has;
    if (!has) return;

    const r = compute();
    state.last = r;

    $('#txRefund').textContent = money(r.refund);
    $('#txRate').textContent = fmt(T.rate_line, { rate: (r.rate * 100).toFixed(0) });

    // Разбор по строкам — чтобы число можно было проверить, а не принять.
    const rows = $('#txRows');
    rows.textContent = '';
    addRow(rows, T.row_income, money(state.income));
    addRow(rows, T.row_tax, money(r.tax));
    if (state.simple) {
        addRow(rows, T.row_simple, money(state.simple)
            + (r.simpleCut > 0 ? ' → ' + money(r.simpleCounted) : ''), r.simpleCut > 0 ? 'warn' : '');
    }
    if (state.expensive) addRow(rows, T.row_expensive, money(state.expensive), 'good');
    addRow(rows, T.row_deduction, money(r.deduction), 'strong');

    // Предупреждения — по одному на каждую настоящую причину, без общих слов.
    const notes = $('#txNotes');
    notes.textContent = '';

    if (r.simpleCut > 0) {
        addNote(notes, fmt(T.note_over_limit, {
            cut: money(r.simpleCut),
            limit: money(CFG.socialLimit),
            room: money(r.roomInLimit),
        }), 'warn');
    }
    if (r.capped) {
        addNote(notes, fmt(T.note_capped, { tax: money(r.tax) }), 'warn');
    }
    if (state.expensive > 0 && r.codeGain > 500) {
        addNote(notes, fmt(T.note_code2_gain, {
            gain: money(r.codeGain),
            ifSimple: money(r.refundIfAllSimple),
        }), 'good');
    }
    if (state.expensive === 0 && state.simple > CFG.socialLimit) {
        // Самая дорогая ошибка: импланты, записанные кодом 1.
        addNote(notes, T.note_check_code, 'warn');
    }
    if (r.rate > 0.13) {
        addNote(notes, fmt(T.note_progressive, { rate: (r.rate * 100).toFixed(0) }), 'good');
    }

    if (window.__aeFunnel) {
        window.__aeFunnel('calculated', {
            expensive: state.expensive > 0 ? 1 : 0,
            // Чем ограничен возврат — это и есть ответ, который удивляет:
            // «я потратил 200 000, а вернут 19 500».
            capped: r.capped ? 1 : 0,
            limited: r.refund < r.tax && !r.capped ? 1 : 0,
        });
    }
}

function addRow(box, label, value, kind) {
    const d = document.createElement('div');
    d.className = 'tx-row' + (kind ? ' tx-' + kind : '');
    const l = document.createElement('span');
    l.textContent = label;
    const v = document.createElement('b');
    v.textContent = value;
    d.append(l, v);
    box.appendChild(d);
}

function addNote(box, text, kind) {
    const d = document.createElement('p');
    d.className = 'tx-note tx-note-' + (kind || 'info');
    d.textContent = text;
    box.appendChild(d);
}

function money(n) {
    return Math.round(n).toLocaleString(window.__LOCALE || 'ru') + ' ₽';
}

async function copySummary() {
    const r = state.last;
    if (!r) return;
    const text = [
        T.copy_head,
        fmt(T.copy_income, { income: money(state.income) }),
        state.simple ? fmt(T.copy_simple, { n: money(state.simple) }) : '',
        state.expensive ? fmt(T.copy_expensive, { n: money(state.expensive) }) : '',
        fmt(T.copy_refund, { n: money(r.refund), rate: (r.rate * 100).toFixed(0) }),
    ].filter(Boolean).join('\n');
    try {
        await navigator.clipboard.writeText(text);
        window.__toast && window.__toast(T.copied, 'success');
    } catch (e) { window.__handleError(e, 'tax:copy'); }
}

function fmt(tpl, vars) {
    return String(tpl || '').replace(/:(\w+)/g, (m, k) => (k in vars ? String(vars[k]) : m));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

// Экспорт для сторожа: считать налог должен ОДИН код, а не два.
window.__taxDeductionInternals = { taxOn, refundFor, effectiveRate };
